(function initTrackingDebug() {
  const params = new URLSearchParams(window.location.search);
  const enabled =
    params.get("trackingDebug") === "1" || localStorage.getItem("qf_tracking_debug") === "1";

  if (!enabled || window.QFTrackingDebug) return;

  const STORAGE_KEY = "qf_tracking_debug_results";
  const EXPECTED_EVENTS = [
    {
      key: "consent_default",
      label: "consent default",
      match: (entry) => isConsent(entry, "default"),
      validate: validateConsent,
    },
    {
      key: "consent_update",
      label: "consent update",
      match: (entry) => isConsent(entry, "update"),
      validate: validateConsent,
    },
    { key: "user", label: "user", match: eventIs("user") },
    {
      key: "view_list_item",
      label: "view_list_item",
      match: eventIs("view_list_item"),
      validate: validateItems,
    },
    {
      key: "select_item",
      label: "select_item",
      match: eventIs("select_item"),
      validate: validateItems,
    },
    { key: "view_item", label: "view_item", match: eventIs("view_item"), validate: validateItems },
    { key: "search", label: "search", match: eventIs("search") },
    {
      key: "add_to_basket",
      label: "add_to_basket",
      match: eventIs("add_to_basket"),
      validate: validateItems,
    },
    { key: "view_cart", label: "view_cart", match: eventIs("view_cart"), validate: validateItems },
    {
      key: "remove_from_cart",
      label: "remove_from_cart",
      match: eventIs("remove_from_cart"),
      validate: validateItems,
    },
    { key: "sign_up", label: "sign_up", match: eventIs("sign_up") },
    { key: "login", label: "login", match: eventIs("login") },
    { key: "logout", label: "logout", match: eventIs("logout") },
    { key: "pop_up_type", label: "pop_up_type", match: eventIs("pop_up_type") },
    { key: "contact_us", label: "contact_us", match: eventIs("contact_us") },
    { key: "select_faq", label: "select_faq", match: eventIs("select_faq") },
    {
      key: "reviews_widget_viewed",
      label: "reviews_widget_viewed",
      match: eventIs("reviews_widget_viewed"),
    },
    {
      key: "reviews_stars_clicked",
      label: "reviews_stars_clicked",
      match: eventIs("reviews_stars_clicked"),
    },
    { key: "find_my_food", label: "find_my_food", match: eventIs("find_my_food") },
    { key: "pet_passport", label: "pet_passport", match: eventIs("pet_passport") },
    { key: "exception", label: "exception", match: eventIs("exception") },
    {
      key: "find_stockist",
      label: "find_stockist",
      match: eventIs("find_stockist"),
      validate: (entry) =>
        Boolean(entry?.ecommerce && "location" in entry.ecommerce && "distance" in entry.ecommerce),
    },
  ];

  function eventIs(eventName) {
    return (entry) => entry?.event === eventName;
  }

  function isConsent(entry, consentType) {
    return (
      isArgumentsLike(entry) &&
      entry[0] === "consent" &&
      entry[1] === consentType &&
      typeof entry[2] === "object"
    );
  }

  function validateConsent(entry) {
    const consent = entry?.[2] || {};
    return ["ad_storage", "analytics_storage", "ad_user_data", "ad_personalization"].every(
      (key) => consent[key] === "granted" || consent[key] === "denied",
    );
  }

  function validateItems(entry) {
    const items = entry?.ecommerce?.items;
    if (!Array.isArray(items) || !items.length) return false;

    return items.every((item) => item && ("item_id" in item || "item_name" in item));
  }

  function isArgumentsLike(value) {
    return Object.prototype.toString.call(value) === "[object Arguments]" || Array.isArray(value);
  }

  function readResults() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  }

  function writeResults(results) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(results));
    } catch {
      // Debug only; ignore storage failures.
    }
  }

  function normalizeEntry(entry) {
    if (isArgumentsLike(entry)) return Array.from(entry);
    return entry;
  }

  function record(entry) {
    const normalized = normalizeEntry(entry);
    const results = readResults();

    EXPECTED_EVENTS.forEach((expected) => {
      if (!expected.match(normalized)) return;

      const passed = expected.validate ? expected.validate(normalized) : true;
      results[expected.key] = {
        passed,
        label: expected.label,
        event: normalized?.event || `${normalized?.[0]} ${normalized?.[1]}`,
        lastSeen: new Date().toISOString(),
        sample: normalized,
      };
    });

    writeResults(results);
  }

  function report() {
    const results = readResults();
    const rows = EXPECTED_EVENTS.map((expected) => {
      const result = results[expected.key];
      return {
        status: result?.passed ? "yes" : "no",
        check: expected.label,
        lastSeen: result?.lastSeen || "",
      };
    });

    console.group("QF GTM Tracking Debug");
    rows.forEach((row) => {
      const icon = row.status === "yes" ? "✓" : "✗";
      const suffix = row.lastSeen ? ` (${row.lastSeen})` : "";
      console.log(`${icon} ${row.check}${suffix}`);
    });
    console.table(rows);
    console.groupEnd();

    return rows;
  }

  function reset() {
    sessionStorage.removeItem(STORAGE_KEY);
    console.log("QF GTM Tracking Debug reset");
    return report();
  }

  function inspect(keyOrEvent) {
    const results = readResults();
    const result =
      results[keyOrEvent] || Object.values(results).find((item) => item.event === keyOrEvent);
    console.log(result || null);
    return result || null;
  }

  window.QFTrackingDebug = {
    expected: EXPECTED_EVENTS.map(({ key, label }) => ({ key, label })),
    inspect,
    record,
    report,
    reset,
  };

  const originalPush = window.dataLayer.push.bind(window.dataLayer);
  window.dataLayer.push = function debugDataLayerPush(...entries) {
    entries.forEach(record);
    const result = originalPush(...entries);
    window.clearTimeout(window.QFTrackingDebug._reportTimer);
    window.QFTrackingDebug._reportTimer = window.setTimeout(report, 250);
    return result;
  };

  window.dataLayer.forEach(record);

  console.log(
    "QF GTM Tracking Debug enabled. Use QFTrackingDebug.report(), QFTrackingDebug.reset(), or QFTrackingDebug.inspect('event_name').",
  );
  report();
})();
